import * as React from 'react';
import { useState } from 'react';
import { Button } from '../../../../../../shared/ui/button';
import { Flex } from '../../../../../components/common/flex';
import { Modal } from '../../../../../components/common/modal';
import { Select, SelectOption } from '../../../../../components/common/select';
import { TextField } from '../../../../../components/common/text_field';
import { useResize } from '../../../../../hooks/use_resize';
import { IBookCancellationModalProps } from './book_cancellation_modal.d';

export const BookCancellationModal: React.FC<IBookCancellationModalProps> = ({
  open,
  onClose,
  cancellationReasons,
  onSubmit,
}) => {
  const [selectedReason, setSelectedReason] = useState<SelectOption>(null);
  const [extraReason, setExtraReason] = useState<string>('');

  const { isMobile } = useResize();

  return (
    <Modal
      open={open}
      onClose={onClose}
      footer={
        <>
          <Button variant={'outline'} onClick={onClose}>
            Отмена
          </Button>
          <Button
            disabled={selectedReason == null}
            variant={'filled'}
            color={'danger'}
            onClick={() => onSubmit({ cancellation_reason: `${selectedReason.label} ${extraReason}` })}
          >
            Отказаться
          </Button>
        </>
      }
      className={'book-action-modal modal_mobile-height_auto'}
      size={isMobile ? 'xs' : 'sm'}
    >
      <div className={'typography-h2'}>Корректировка заявки</div>
      <div>Укажите причину отказа:</div>

      <Flex vertical gap={'middle'}>
        <Select
          label={'Причина'}
          placeholder={'Причина'}
          options={cancellationReasons}
          value={selectedReason}
          onChange={setSelectedReason}
          forcePositionBottom
        />
        <TextField placeholder={'Описание причины отказа'} value={extraReason} onChange={setExtraReason} />
      </Flex>
    </Modal>
  );
};
